import React, { useState, useEffect } from "react";
import { graphicEvents } from "../../lib/graphic/GraphicEvents";
import { graphic } from "../../lib/graphic/Graphic";

import './MapTools.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDotCircle, faSearchPlus } from "@fortawesome/free-solid-svg-icons";
import { faSearchMinus } from "@fortawesome/free-solid-svg-icons/faSearchMinus";

export function MapTools() {
    const [value, setValue] = useState(1);

    useEffect(() => {
        graphicEvents.on('ON_CHANGE_ZOOM', value => setValue(value));
    }, []);

    const decreaseZoom = () => {
        graphicEvents.trigger('DECREASE_ZOOM');
    };

    const increaseZoom = () => {
        graphicEvents.trigger('INCREASE_ZOOM');
    };

    const center = () => {
        graphic.setZoom({ value: 1 });
        graphic.center();
    };

    return (
        <div className="MapTools-zoom">

            <button
                title={'Centrer'}
                className={'MapTools-zoom-button MapTools-zoom-minus'}
                onClick={center}
                onMouseDown={e => e.preventDefault()}
            >
                <FontAwesomeIcon icon={faDotCircle}/>
            </button>

            <button
                title={'Dézoomer'}
                className={'MapTools-zoom-button MapTools-zoom-minus'}
                onClick={decreaseZoom}
                onMouseDown={e => e.preventDefault()}
            >
                <FontAwesomeIcon icon={faSearchMinus}/>
            </button>

            <button
                title={'Zoomer'}
                className={'MapTools-zoom-button MapTools-zoom-plus'}
                onClick={increaseZoom}
                onMouseDown={e => e.preventDefault()}
            >
                <FontAwesomeIcon icon={faSearchPlus}/>
            </button>

            <span className={'MapTools-zoom-value'}>x{value}</span>
        </div>
    )
}